import KickImage from 'Reuseables/KickImage';
import _ from 'lodash';
import { connect } from 'react-redux';

import { IconContext } from 'react-icons';
import ReactLoading from 'react-loading';
import moreIcon from '../../../images/more.png';

import { _VERIFYING_BID, _VERIYING_PAYMENT } from '../../../utils/Constants';
import {
  accessoriesCondition,
  boxCondition,
  boxHandbag,
  displayItem,
  dustBag,
  formatCurrency,
  handbagCondition,
  handleImageCategory,
  sneakerDefectsCondition,
  sneakersCondition,
  sneakersDefect,
  yellowing
} from '../../../utils/Helpers';
import TableHeader from '../components/TableHeader';

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
import { OfferInterface } from '../../../interface/bid';
import AuthInterface from '../../../interface/reducers/auth';
import DataHistoryInterface, {
  DataPenjualanInterface,
  PenjualanInterface,
} from '../../../interface/reducers/history';
// ====== end of interface import section ====== //

import { setSelectedUserSell } from 'actions/saleActions';
import { useState } from 'react';
import { useHistory } from "react-router-dom";
import EMPTY_STATE from '../../../images/dashboard-empty-state.jpg';
import HOLIDAY_MODE from '../../../images/holidaymode1024.png';
import ExpiryButtonWrapper from '../components/ListingExpiryButton';
import ModalCurrent from '../components/ModalCurrent';
import Styles from "./Current.module.scss";
import CreditMinus from "./components/CreditMinus";
import Suspended from "./components/Suspended";

const moreIconNew: any = moreIcon;

type stateToProps = {
  dataHistory: DataHistoryInterface;
  dataAuth: AuthInterface;
};

interface CurrentInterface {
  dataSelling: PenjualanInterface;
  roles: string[];
  ratio: number;
  currency: string;
  isHoliday: boolean;
  callbackAfterUpdate: (...args: any) => any;
  loading: boolean;
  dataAuth: any;
  setIsOpenModalAlert: () => any;
  selectUserSell: (param) => any;
}

/**
 * Current tab on Selling User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {CurrentInterface} props for this component.
 * @return {JSX.Element}
 */
function CurrentTab({
  dataSelling,
  roles,
  ratio,
  currency,
  isHoliday,
  callbackAfterUpdate,
  loading,
  dataAuth,
  setIsOpenModalAlert,
  seller_points,
  selectUserSell
}: CurrentInterface): JSX.Element {
  const history = useHistory();
  const hasSuspendedSeller = dataAuth?.userdata?.roles?.includes('suspended_seller');
  const sellerPointsLessThanFive = parseInt(seller_points) < 5;
  const isSuspended = hasSuspendedSeller || sellerPointsLessThanFive;

  const isSellerCreditMinus = parseInt(dataAuth?.userdata?.balance_with_fee ?? "0") < 0

  const [isModalOpened, setModalOpened] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const checkOffer = (offer: OfferInterface[]) => {
    let result = offer.filter(
      (data, index) =>
        data.status === _VERIYING_PAYMENT[0] ||
        data.status === _VERIFYING_BID[0],
    );
    return result.length > 0 ? true : false;
  };
  /**
   * Table item for Offer List in Buying Dashboard
   * @param {DataPenjualanInterface} item
   * @return {JSX.Element}
   */
  function renderItem(item: DataPenjualanInterface): JSX.Element {
    const isDefects = item?.defects?.length > 0
    const uniqueDefects = _.uniqBy(
      isDefects ? item.defects : null,
      'name',
    );
    const dustBagCondition = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'DUST_BAG' && a.value)
      : {};
    const boxConditions = uniqueDefects
      ? uniqueDefects.find((a: any) => a.name === 'BOX')
      : {};
    const hideBoxInfo = item.product_variant.hide_box_info;
    const isVintage = item.product_variant.vintage;
    const sneakersDetailArr = [
      isVintage ? "Vintage" : sneakersCondition(item.sneakers_condition),
      hideBoxInfo ? '' : boxCondition(item.box_condition),
      accessoriesCondition(item.missing_accessories),
      yellowing(item.yellowing),
      displayItem(item.display_item),
      sneakersDefect(item.sneakers_defect),
      isDefects ? sneakerDefectsCondition(uniqueDefects) : '',
    ];
    const sneakersDetail = sneakersDetailArr
      .filter((item) => item !== '')
      .map((item) => item)
      .join(' / ');
    const luxuryDetailArr = [
      sneakersCondition(item.sneakers_condition),
      accessoriesCondition(item.missing_accessories),
      dustBag(dustBagCondition),
      hideBoxInfo ? '' : boxHandbag(boxConditions),
      isDefects ? handbagCondition(uniqueDefects) : '',
    ];
    const luxuryDetail = luxuryDetailArr
      .filter((item) => item !== '' && item !== 'Missing Box')
      .map((item) => item)
      .join(' / ');
    const handleClickedDetail = () => {
      setSelectedData(item);
      setModalOpened(true);
    };

    const category = item?.product_variant?.product?.category?.name;
    const getMinPhotos = (item: DataPenjualanInterface): number => {
      if (
        item.sneakers_condition === 'BEKAS' &&
        category === 'sneakers'
      ) {
        return 7;
      } else if (
        item.missing_accessories ||
        item.yellowing ||
        item.display_item ||
        item.sneakers_defect
      ) {
        return 6;
      } else {
        if (category === 'handbags') {
          return 6;
        } else {
          return 5;
        }
      }
    }
    const isTicket = item?.product_variant?.product?.name.includes('Ticket');
    const isGreaterThanLowestAsk = parseInt(item.asking_price) > parseInt(item.lowest_ask);
    const isExpiredWaitingInLine = item.status == 'approved' && item.quantity > 0 && parseInt(item.lowest_ask) === 0 && item.is_expired;
    const isWaitingInLine = item.status == 'approved' && item.quantity > 0 && parseInt(item.lowest_ask) !== 0;
    const isOutOfStock = item.status === 'approved' && item.quantity <= 0;
    const isAwaitingReview = item.status == 'awaiting_review';

    const displayingStatus = () => {
      if (isGreaterThanLowestAsk) {
        if (checkOffer(item.offer)) {
          return (
            <>
              <p className={'normal'}>UNDER RESERVATION</p>
              <p>{formatCurrency(item.asking_price, ratio, currency)}</p>
            </>
          )
        } else {
          if ((isExpiredWaitingInLine) || (isWaitingInLine) ) {
            return (
              <>
                <p className={'normal'}>WAITING IN LINE</p>
                <p className={'red'}>
                  {formatCurrency(item.asking_price, ratio, currency)}
                </p>
                <div className={'box'}>
                  <p className={'lowest'}>Lowest Ask</p>
                  <p className={'price'}>
                    {formatCurrency(item.lowest_ask, ratio, currency)}
                  </p>
                </div>
              </>
            ) 
          } else {
            if (isOutOfStock) {
              return (
                <p className={'normal'}>Out of Stock</p>
              )
            } else {
              return (
                <>
                  <div className={Styles['flex-row']}>
                    <p className={'normal'}>AWAITING REVIEW</p>
                  </div>
                  
                  <p className={'red'}>
                    {formatCurrency(item.asking_price, ratio, currency)}
                  </p>
                </>
              )
            }
          }
        }
      } else {
        if (checkOffer(item.offer)) {
          return (
            <>
              <p className={'normal'}>UNDER RESERVATION</p>
              <p>{formatCurrency(item.asking_price, ratio, currency)}</p>
            </>
          )
        } else if (isAwaitingReview) {
          return (
            <>
              <div className={Styles['flex-row']}>
                <p className={'normal'}>AWAITING REVIEW</p>
              </div>
              
              <p className={'red'}>
                {formatCurrency(item.asking_price, ratio, currency)}
              </p>
            </>
          )
        } else {
          return (
            <p>{formatCurrency(item.asking_price, ratio, currency)}</p>
          )
        }
      }
    }


    return (
      <div className={'item-table'}>
        <div className={'product-container selling'}>
          <KickImage
            src={handleImageCategory(isTicket, category.toLowerCase())}
            className={'image-category'}
          />
          <div>
            <p className={'title'}>{item.product_variant.display_name}</p>
            {category === 'handbags' ||
            (category === 'lifestyles' &&
              item.size?.US.toLowerCase() !== 'all size') ? (
              <div className={'size-container'}>
                <p>{item.size?.US}</p>
              </div>
            ) : (
              <div className={'size-container'}>
                <p>US {item.size?.US}</p>
              </div>
            )}
            {
              isTicket ?
              <p className={'condition'}>{sneakersCondition(item.sneakers_condition)}</p> :
              <p className={'condition'}>
                {category !== 'handbags'
                  ? sneakersDetail
                  : luxuryDetail}
              </p>
            }
            <p className={'extra'}>{item?.product_variant?.colour}</p>
            <p className={'extra'}>
              Consignment ID: {item?.consignment_id ?? '-'}
            </p>
          </div>
        </div>
        <div className={'price-container'}>
          {displayingStatus()}
          {item.highest_bid && (
            <div className={'box'}>
              <p className={'lowest'}>Highest Offer</p>
              <p className={'price'}>
                {formatCurrency(item.highest_bid.amount, ratio, currency)}
              </p>
            </div>
          )}

          {
            item.status === "draft" && 
            item.user_sell_images?.length < getMinPhotos(item) &&
            (
              <div 
                className={'box'} 
                onClick={()=>{
                  selectUserSell(item);
                  history.push(`/sell-request/${item.id}`);
                }} 
                style={{cursor: 'pointer'}}
              >
                <p className={'lowest'}>Edit Listing</p>
              </div>
            )
          }
        </div>
        <div className={'expiry-container'}>
          {item ? <ExpiryButtonWrapper item={item} /> : null}
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div className={'icon-container'} onClick={handleClickedDetail}>
              {/* <MdSettings /> */}
              <KickImage src={moreIconNew} alt="..." />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    );
  }

  /**
   * Rendering Empty State UI
   * @return {JSX.Element}
   */
  function renderEmpty() {
    return (
      <div className={'empty-container'}>
        <KickImage src={EMPTY_STATE} />
        <p>
          It seems you haven’t got anything on sale yet. Why don’t you hit the
          <span>Sell Request Form</span> button above and join our lucrative
          community..
        </p>
        <div className={'button-refresh'} onClick={callbackAfterUpdate}>
          <p>Refresh</p>
        </div>
      </div>
    );
  }

  /**
   * Rendering Holiday Mode UI
   * @return {JSX.Element}
   */
  function renderHoliday() {
    return (
      <>
        {isSuspended ?
          <Suspended onClick={() => setIsOpenModalAlert()} />
          :
          !isSellerCreditMinus ?
            <div className={`empty-container`}>
              <KickImage src={HOLIDAY_MODE} />
              <p className={'title'}>Holiday mode is currently set to active</p>
              <p className={'bottom-text'}>
                All your listings are being temporarily deactivated. You can anytime
                re-activate your listings. Enjoy your break!
              </p>
            </div>
            :
            <CreditMinus onClick={() => setIsOpenModalAlert()} />
        }
      </>
    );
  }

  return (
    <div>
      <TableHeader
        getData={callbackAfterUpdate}
        type={'current'}
        mode={'selling'}
        isHoliday={isHoliday}
      />
      <div className={'table-container'}>
        <div className={'header-table'}>
          <div className={'product-container'}>
            <span>Product</span>
          </div>
          <div className={'price-container'}>
            <span>Selling Price</span>
          </div>
          <div className={'expiry-container'}>
            <span>Expiry Date</span>
          </div>
        </div>
        <div className={'body-table'}>
          {(isHoliday || isSuspended) ? (
            renderHoliday()
          ) : dataSelling.isFetch || loading ? (
            <div className={'empty-container'}>
              <ReactLoading
                type={'spin'}
                height={50}
                width={50}
                color={'#159953'}
              />
            </div>
          ) : dataSelling.dataPenjualan.length ? (
            dataSelling.dataPenjualan.map((item) => renderItem(item))
          ) : (
            renderEmpty()
          )}
        </div>
      </div>
      <ModalCurrent
        isOpen={isModalOpened}
        onToggle={() => setModalOpened(false)}
        callbackAfterUpdate={callbackAfterUpdate}
        data={selectedData}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataSelling: state.dataHistory.penjualan,
    roles: state.dataAuth.userdata.roles,
    ratio: state.dataAuth.userCurrency.ratio,
    currency: state.dataAuth.userCurrency.currency,
    isHoliday: state.dataAuth.userdata.is_holiday,
    dataAuth: state.dataAuth,
    seller_points: state.dataAuth.userdata.seller_points,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    selectUserSell: (payload) => dispatch(setSelectedUserSell(payload))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentTab);
